import { useMemo } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { makeAuthedRequest } from "shared/utils/makeAuthedRequest";

import processSteps from "../../processSteps";

export function useSteps({ contact }) {
  const queryClient = useQueryClient();
  const { isLoading, isError, data, error } = useQuery("/prospects/steps");

  // console.log(contact.progression);

  const steps = useMemo(() => {
    if (data != null) {
      return data.map((s) => ({
        ...s,
        ...processSteps.find((p) => p.name === s.name),
      }));
    }
  }, [data]);

  const addStepMutation = useMutation(
    (stepId) =>
      makeAuthedRequest("/prospects/step", {
        method: "post",
        body: JSON.stringify({
          id: stepId,
          contactId: contact.id,
        }),
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(`/contacts/${contact.id}`);
        queryClient.invalidateQueries(`/contacts`);
      },
    }
  );

  const undoStepMutation = useMutation(
    (stepId) =>
      makeAuthedRequest(`/prospects/step/${contact.id}/${stepId}`, {
        method: "delete",
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries(`/contacts/${contact.id}`);
        queryClient.invalidateQueries(`/contacts`);
      },
    }
  );

  return {
    isLoading,
    isError,
    steps,
    error,

    addStepMutation,
    undoStepMutation,
  };
}
